module.exports = __webpack_public_path__ + "static/preview-8-c91573b7c33507cc5455aac7bd6f9da3.png";